// Per-deployment frontend branding. Override via VITE_BRAND_* in .env
// (see .env.example / docs/FORKING.md). Defaults are the Ikali deployment.
const env = import.meta.env;

export const BRAND_NAME = env.VITE_BRAND_NAME || "Sol y Sereno";                    // human-readable venue name
export const BRAND_SHORT = env.VITE_BRAND_SHORT || "Sol y Sereno";                  // compact label (admin sidebar)
export const BRAND_WORDMARK = env.VITE_BRAND_WORDMARK || "SOL y SERENO";            // attract-screen display word
export const BRAND_TAGLINE = env.VITE_BRAND_TAGLINE || "Café-Bar de Barrio";        // small line above/below wordmark
export const BRAND_TAG = env.VITE_BRAND_TAG || "SOL · Y · SERENO · CAFÉ-BAR DE BARRIO"; // monospace ticker line
export const BRAND_TAG_CITY = env.VITE_BRAND_TAG_CITY || `${BRAND_TAG} · MTY`;
export const BRAND_TITLE = env.VITE_BRAND_TITLE || "Sol y Sereno · Café-Bar de Barrio"; // document title
